import { BracketPeriod, getBracketPeriod, useRootContext } from '../contexts/RootContext'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuthContext } from '../contexts/AuthContext'
import BracketFormPhaseOne from '../BracketForm/BracketFormPhaseOne'
import { useToast } from '../contexts/ToastContext'
import React, { useEffect, useState } from 'react'
import { removeWhiteSpace } from '../utils/utils'
import PageLoading from '../misc/PageLoading'
import { WC_NAME } from '../utils/Constants'
import Error from '../Error/Error'

export default function BracketEditForm() {
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const [bracket, setBracket] = useState({})

  const bracketPeriod = getBracketPeriod()
  const { authorizationHeaders } = useAuthContext()
  const { secondChanceAvailabilityLoaded, secondChanceAvailable, setBracketsLoaded } = useRootContext()
  const { errorToast, successToast } = useToast()
  const navigate = useNavigate()
  const { id } = useParams()

  useEffect(() => {
    if (!secondChanceAvailabilityLoaded) return

    if (!(bracketPeriod === BracketPeriod.Open || secondChanceAvailable)) {
      setError({ status: 403 })
      setLoading(false)
      return
    }

    fetch(`/api/v2/brackets/${id}`, {
      credentials: 'same-origin',
      headers: authorizationHeaders,
    })
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw(response)
        }
      })
      .then(body => {
        if (!body.can_edit) {
          setError({ status: 403 })
          setLoading(false)
          return
        }

        setBracket(body.bracket)
        setLoading(false)
      })
      .catch(fetchError => {
        setError(fetchError)
        setLoading(false)
      })
  }, [authorizationHeaders, bracketPeriod, id, secondChanceAvailabilityLoaded, secondChanceAvailable])

  if (loading) {
    return <div className={removeWhiteSpace(WC_NAME)}>
      <div className="background-image bracket-form-background"/>
      <PageLoading />
    </div>
  }
  if (error) return <Error error={error} />

  const updateBracket = (picks) => {
    fetch(`/api/v2/brackets/${id}`, {
      method: "PUT",
      body: JSON.stringify({ picks }),
      credentials: 'same-origin',
      headers: authorizationHeaders,
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw(response);
        }
      })
      .then(() => {
        setBracketsLoaded(false)
        navigate(`/brackets/${id}`)
        successToast('Bracket saved')
      })
      .catch(error => {
        errorToast('Changes could not be saved at this time.')
        return error.json()
          .then(message => {
            errorToast(`${error.status} (${message.error})`)
          })
      });
  }

  return <BracketFormPhaseOne
    authorizationHeaders={authorizationHeaders}
    editing={bracket}
    poolId={bracket.pool_id}
    updateBracket={updateBracket}
  />
}
